<!--
加工・出荷登録画面
URL：shipping
-->

<template>
  <div>
    <v-container style="max-width: 800px" v-show="view_status.editable">
      <p class="text-center text-h3">加工・出荷</p>
      <alert :errors="errors" css_class="ma-1"></alert>
      <v-card elevation="5" class="ma-4">
        <v-card-title class="custom-card-title">加工・出荷日</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <custom-date-picker
                :dateSub="dateSub"
                :events="events"
                :defaultFocus="dateSub"
                :recordType="recordTypeShipping"
                @on-update-registration-date="updateRegistrationDate"
                @on-update-calendar-month="updateCalendarEvent"
              ></custom-date-picker>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card
        elevation="5"
        :class="{ 'card-error': cardColor2 == 30 }"
        class="ma-4"
      >
        <v-card-title class="custom-card-title">水揚げ日</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <custom-date-picker
                :dateSub="unloadingDateSub"
                :events="events"
                :recordType="recordTypeUnloading"
                @on-update-registration-date="updateUnloadingDate"
                @on-update-calendar-month="updateCalendarEvent"
              ></custom-date-picker>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-title class="custom-card-title">水揚げ登録内容</v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <font class="custom-card-text ma-4">{{ unloadingDataText }}</font>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-title class="custom-card-title">採取海域区分</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="auto" style="margin-top: 32px; margin-bottom: 32px">
              <v-radio-group
                v-model="checkSeaArea"
                class="big-radio-group"
                @change="changeSeaArea"
              >
                <v-radio
                  label="広島湾西部"
                  color="#0ddbc7"
                  :value="1"
                ></v-radio>
                <v-radio
                  label="広島湾北部"
                  color="#0ddbc7"
                  :value="2"
                ></v-radio>
                <v-radio
                  label="広島湾中部"
                  color="#0ddbc7"
                  :value="3"
                ></v-radio>
                <v-radio
                  label="広島湾南部"
                  color="#0ddbc7"
                  :value="4"
                ></v-radio>
                <v-radio label="呉湾" color="#0ddbc7" :value="5"></v-radio>
                <v-radio label="広湾" color="#0ddbc7" :value="6"></v-radio>
                <v-radio label="三津湾" color="#0ddbc7" :value="7"></v-radio>
                <v-radio
                  label="広島県東部"
                  color="#0ddbc7"
                  :value="8"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card
        elevation="5"
        :class="{ 'card-error': cardColor3 == 30 }"
        class="ma-4"
      >
        <v-card-title class="custom-card-title">結束ヒモの色</v-card-title>
        <v-card-text>
          <v-row v-if="cordColorMsg" align-content="center">
            <v-col cols="auto" align="left">
              <font color="red" class="custom-card-text">
                {{ cordColorMsg }}
              </font>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="auto" style="margin-top: 32px; margin-bottom: 32px">
              <v-radio-group v-model="checkCordColor" class="big-radio-group">
                <v-radio label="黄" color="#0ddbc7" :value="1"></v-radio>
                <v-radio label="赤" color="#0ddbc7" :value="2"></v-radio>
                <v-radio label="橙" color="#0ddbc7" :value="3"></v-radio>
                <v-radio label="白" color="#0ddbc7" :value="4"></v-radio>
                <v-radio label="青" color="#0ddbc7" :value="5"></v-radio>
                <v-radio label="緑" color="#0ddbc7" :value="6"></v-radio>
                <v-radio label="紫" color="#0ddbc7" :value="7"></v-radio>
                <v-radio label="黒" color="#0ddbc7" :value="8"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card
        elevation="5"
        :class="{ 'card-error': cardColor4 == 30 }"
        class="ma-4"
      >
        <v-card-title class="custom-card-title"
          >むき身作業中の冷却方法</v-card-title
        >
        <v-card-subtitle class="custom-card-subtitle"
          >※複数選択可</v-card-subtitle
        >
        <v-card-text v-model="weightInput">
          <v-row style="margin-left: 32px">
            <v-col cols="auto">
              <v-checkbox
                class="big-checkbox"
                label="ペットボトル氷"
                color="#0ddbc7"
                v-model="coolingmethodPet"
              ></v-checkbox>
              <v-checkbox
                class="big-checkbox"
                label="海水氷"
                color="#0ddbc7"
                v-model="coolingmethodSeaWater"
              ></v-checkbox>
              <v-text-field
                label="その他"
                :Width="12"
                color="#0ddbc7"
                ref="coolingmethodOther"
                v-model="coolingmethodOther"
                regular
                hide-details="auto"
                class="text-h6 text-align:center"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card
        elevation="5"
        :class="{ 'card-error': cardColor5 == 30 }"
        class="ma-4"
      >
        <v-card-title class="custom-card-title">出荷前冷蔵</v-card-title>
        <v-card-text>
          <v-row v-if="refrigerateMsg" align-content="center">
            <v-col cols="auto" align="left">
              <font color="red" class="custom-card-text">{{
                refrigerateMsg
              }}</font>
            </v-col>
          </v-row>
          <v-card-text>
            <v-row style="margin-left: 32px">
              <v-col cols="auto" style="margin-top: 32px; margin-bottom: 32px">
                <v-radio-group v-model="refrigerate" class="big-radio-group">
                  <v-row>
                    <v-col cols="6">
                      <v-radio
                        label="冷蔵庫"
                        color="#0ddbc7"
                        :value="2"
                      ></v-radio>
                    </v-col>

                    <v-col cols="3">
                      <v-text-field
                        :Width="12"
                        color="#0ddbc7"
                        v-model="$v.formData.refrigerateTemperature.$model"
                        maxlength="8"
                        regular
                        hide-details="auto"
                        dense
                        class="text-h6 text-align:center"
                        :disabled="refrigerate != 2"
                        :error-messages="refrigerateTemperatureErrorMessage"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="3">
                      <v-card-text> ℃ </v-card-text>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="auto">
                      <v-radio
                        label="なし"
                        color="#0ddbc7"
                        :value="1"
                      ></v-radio>
                    </v-col>
                  </v-row>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card-text>
      </v-card>

      <append-destination-card
        @on-change-destination="onChangeDestination"
        ref="appendDestinationCard"
      ></append-destination-card>
      <append-destination-label-card
        ref="appendDestinationLabelCard"
      ></append-destination-label-card>

      <v-row justify="center" style="text-align: center">
        <v-col cols="6">
          <v-btn
            color="secondary"
            outlined
            style="font-size: 24px"
            class="ma-2"
            width="200"
            height="50"
            @click="cancel"
            >やめる</v-btn
          >
        </v-col>
        <v-col cols="6">
          <v-btn
            color="primary"
            style="font-size: 24px"
            class="ma-2"
            width="200"
            height="50"
            @click="inputCheck"
            :disabled="!view_status.editable"
            >保存</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
    <!-- 入力チェックダイアログ -->
    <confirm-dialog ref="confirm_input_check" @on-click-ok="register">
      <p v-if="cordColorMsg">結束ヒモの色:{{ cordColorMsg }}</p>
      <p v-if="refrigerateMsg">出荷前冷蔵:{{ refrigerateMsg }}</p>
      <p v-if="destinationLabelCardMsg">
        出荷ラベル:{{ destinationLabelCardMsg }}
      </p>
    </confirm-dialog>
  </div>
</template>

<script>
import CustomDatePicker from "../components/record-update/custom-date-picker.vue";
import AppendDestinationCard from "../components/record-update/append-destination-card.vue";
import AppendDestinationLabelCard from "../components/record-update/append-destination-label-card.vue";
import Api from "@/logic/api/api.js";
import DateWrapper from "../logic/common/date-wrapper";
import Alert from "../components/common/alert.vue";
import AlertBuilder from "../logic/common/alert-contents";
import valueMapper from "../logic/common/value-mapper";
import Validate from "@/logic/common/validate.js";
import ConfirmDialog from "../components/dialog/confirmWkReg.vue";

const CARD_COLOR_NOMAL = 10;
const CARD_COLOR_ERROR = 30;

export default {
  components: {
    "custom-date-picker": CustomDatePicker,
    "append-destination-card": AppendDestinationCard,
    "append-destination-label-card": AppendDestinationLabelCard,
    "confirm-dialog": ConfirmDialog,
    alert: Alert,
  },
  /**
   * 出入力の検証
   */
  validations: {
    formData: {
      // 冷蔵庫 温度
      refrigerateTemperature: {
        signedDecimalNumber: Validate.rule.signedDecimalNumber,
      },
    },
  },
  computed: {
    /**
     * formDataの入力が不正ならtrueを返す
     */
    hasErrorFormData() {
      return Validate.hasError([this.$v.formData.refrigerateTemperature]);
    },
    /**
     * エラーメッセージ：冷蔵庫 温度
     */
    refrigerateTemperatureErrorMessage() {
      return Validate.buildLocalizedErrorMessage(
        this.$v.formData.refrigerateTemperature,
        "温度",
        ["signedDecimalNumber"]
      );
    },
    /**
     * 業務チェック：結束ひもの色
     */
    cordColorMsg: function () {
      if (this.checkCordColor != this.checkSeaArea) {
        return "採取海域区分と異なります";
      }
      return "";
    },
    /**
     * 業務チェック：出荷前冷蔵
     */
    refrigerateMsg: function () {
      if (this.refrigerate == 1) {
        // 「なし」を選択
        return "5℃以下で保管してください";
      } else if (this.refrigerate == 2) {
        // 「冷蔵庫」を選択
        // 温度入力なし、または５℃より大きい
        if (
          this.formData.refrigerateTemperature == "" ||
          5 < Number(this.formData.refrigerateTemperature)
        ) {
          return "5℃以下で保管してください";
        }
      }
      return "";
    },
    /**
     * 水揚げ登録内容
     */
    unloadingDataText: function () {
      // 水揚げ登録内容がない場合
      if (!this.unloadingData.length) {
        return "-";
      }
      // 水揚げ登録内容がある場合
      var str = "";
      if (this.unloadingData.includes(1)) {
        str += "広島湾西部，";
      }
      if (this.unloadingData.includes(2)) {
        str += "広島湾北部，";
      }
      if (this.unloadingData.includes(3)) {
        str += "広島湾中部，";
      }
      if (this.unloadingData.includes(4)) {
        str += "広島湾南部，";
      }
      if (this.unloadingData.includes(5)) {
        str += "呉湾，";
      }
      if (this.unloadingData.includes(6)) {
        str += "広湾，";
      }
      if (this.unloadingData.includes(7)) {
        str += "三津湾，";
      }
      if (this.unloadingData.includes(8)) {
        str += "広島県東部，";
      }
      str = str.slice(0, -1);
      return str;
    },
    /**
     * カード色
     */
    // 水揚げ日・採取海域区分
    cardColor2: function () {
      if (this.checkSeaArea === "") {
        return CARD_COLOR_ERROR;
      } else {
        return CARD_COLOR_NOMAL;
      }
    },
    // 結束ヒモの色
    cardColor3: function () {
      if (this.checkCordColor === "") {
        return CARD_COLOR_ERROR;
      } else {
        return CARD_COLOR_NOMAL;
      }
    },
    // むき身作業中の冷却方法
    cardColor4: function () {
      let ret = CARD_COLOR_NOMAL;

      if (this.weightInput > 0) {
        if (
          !this.coolingmethodPet &&
          !this.coolingmethodSeaWater &&
          this.coolingmethodOther === ""
        ) {
          ret = CARD_COLOR_ERROR;
        }
      }

      return ret;
    },
    // 出荷前冷蔵
    cardColor5: function () {
      if (this.refrigerate == "") {
        return CARD_COLOR_ERROR;
      } else {
        return CARD_COLOR_NOMAL;
      }
    },
  },
  data() {
    var today = new Date();
    let year = today.getFullYear();
    let month = ("0" + (today.getMonth() + 1)).slice(-2);
    let date = ("0" + today.getDate()).slice(-2);
    // 加工・出荷日 初期値
    this.registrationDate = year + "/" + month + "/" + date;
    // 水揚げ日 初期値
    this.unloadingDate = year + "/" + month + "/" + date;

    // API向け出荷先情報作成
    this.shippingDestinations = []; //初期値
    // API向け出荷ラベル情報作成
    this.shippingLabels = []; //初期値
    // 編集用出荷先情報作成
    this.shippingDestinationsSub = []; //初期値
    // 編集用出荷ラベル情報作成
    this.shippingLabelsSub = []; //初期値

    // 加工・出荷日補完用
    this.dateSub = ""; //初期値
    // 水揚げ日補完用
    this.unloadingDateSub = ""; //初期値
    // カレンダー識別用(加工・出荷日)
    this.recordTypeShipping = "SHIPPING";
    // カレンダー識別用(水揚げ日)
    this.recordTypeUnloading = "UNLOADING";

    // URLから対象のJSON情報を取得
    this.bodyData = "";
    this.mode = "";
    this.id = "";
    if (
      this.$route.params.bodyData &&
      this.$route.params.id &&
      this.$route.params.mode
    ) {
      this.bodyData = JSON.parse(
        decodeURIComponent(this.$route.params.bodyData)
      );

      // 編集時のみ加工・出荷日及び、水揚げ日を補完
      this.mode = JSON.parse(decodeURIComponent(this.$route.params.mode));
      if (this.mode == "EDIT") {
        this.dateSub = this.bodyData.date;
        this.updateRegistrationDate(this.bodyData.date);
        this.unloadingDateSub = this.bodyData.unloading_date.replace(
          /\//g,
          "-"
        );
        this.unloadingDate = this.bodyData.unloading_date;
      }

      this.id = JSON.parse(decodeURIComponent(this.$route.params.id));
    }

    // 新規登録時
    if(this.mode == "") {
      // 最新生産情報補完モードに設定
      this.mode = "LATEST"
      // 最新生産情報取得
      this.bodyData = this.latestSearch();
    }

    this.$nextTick(() => {
      // 最新生産情報取得時以外
      if(this.mode != "LATEST") {
        // 取得情報を画面に設定する
      this.loadData();
      }
    });

    return {
      hasErrorDestinationCard: "",
      hasErrorDestinationLabelCard: "",
      destinationLabelCardMsg: "",
      destinationLabelCardColor: "",
      events: {},
      menu: "",
      view_status: {
        editable: false,
      },
      formData: {
        refrigerateTemperature: "",
      },
      errors: [],
      checkSeaArea: "",
      unloadingData: [],
      checkCordColor: "",
      coolingmethodPet: "",
      coolingmethodSeaWater: "",
      coolingmethodOther: "",
      refrigerate: "",
      destinations: [], // 出荷先
      destinationLabels: [], // 出荷ラベル
      weightInput: 0,
    };
  },
  methods: {
    /**
     * 出荷先の配列関連
     */
    buildShippingDestinations(destinations) {
      if (destinations != null) {
        this.shippingDestinations = [];
        var rowCount = 0;
        for (const row of destinations) {
          if (row.name) {
            // API向け出荷先情報作成
            var shippingDestinationsSub = { shipping_destination: "" };
            var shippingDestination = {
              name: "",
              weight_kg: "",
              weight_can: "",
              num_s_size: "",
              num_m_size: "",
              num_l_size: "",
              num_2l_size: "",
              doubling_rate: "",
            };
            shippingDestination.name = row.name;
            // むき身重量-重量未指定時の処理
            if (row.weight_kg === "") {
              shippingDestination.weight_kg = -1;
            } else {
              shippingDestination.weight_kg = row.weight_kg;
            }
            // むき身重量-缶数未指定時の処理
            if (row.weight_can === "") {
              shippingDestination.weight_can = -1;
            } else {
              shippingDestination.weight_can = row.weight_can;
            }
            // 殻付きSサイズ個数未指定時の処理
            if (row.num_s_size === "") {
              shippingDestination.num_s_size = -1;
            } else {
              shippingDestination.num_s_size = row.num_s_size;
            }
            // 殻付きMサイズ個数未指定時の処理
            if (row.num_m_size === "") {
              shippingDestination.num_m_size = -1;
            } else {
              shippingDestination.num_m_size = row.num_m_size;
            }
            // 殻付きLサイズ個数未指定時の処理
            if (row.num_l_size === "") {
              shippingDestination.num_l_size = -1;
            } else {
              shippingDestination.num_l_size = row.num_l_size;
            }
            // 殻付き2Lサイズ個数未指定時の処理
            if (row.num_2l_size === "") {
              shippingDestination.num_2l_size = -1;
            } else {
              shippingDestination.num_2l_size = row.num_2l_size;
            }
            // 区分の処理
            shippingDestination.doubling_rate = row.doubling_rate;

            // API向け出荷先の配列情報作成
            shippingDestinationsSub.shipping_destination = shippingDestination;
            this.shippingDestinations[rowCount++] = shippingDestinationsSub;
          }
        }
      }
    },
    /**
     * 重量変更時、値を受け取る
     */
    onChangeDestination() {

        this.weightInput = 0;

        // 全てのカード情報を取得
        let desinationsTemp = this.getDestinationsData();

        // むき身重量の入力値を加算しパネルカラー判定用の変数に保持させる
        for (const dest in desinationsTemp) {
          if (desinationsTemp[dest].weight_kg !== "") {
            this.weightInput += Number(desinationsTemp[dest].weight_kg);
          }
          if (desinationsTemp[dest].weight_can !== "") {
            this.weightInput += Number(desinationsTemp[dest].weight_can) * 20;
          }
        }
    },
    /**
     * 出荷ラベルの配列関連
     */
    buildShippingLabels(destinationLabels) {
      if (destinationLabels != null) {
        this.shippingLabels = [];
        var rowCount = 0;
        for (const row of destinationLabels) {
          if (row.name) {
            // API向け出荷ラベル情報作成
            var shippingLabelsSub = { shipping_label: "" };
            var shippingLabel = {
              name: "",
              expiration_date: "",
              preservation_temperature: "",
              processing_person: "",
            };
            shippingLabel.name = row.name;
            shippingLabel.expiration_date = row.expirationDate;
            shippingLabel.preservation_temperature = Number(row.temperature);
            shippingLabel.processing_person = row.processingPerson;

            // API向け出荷ラベルの配列情報作成
            shippingLabelsSub.shipping_label = shippingLabel;
            this.shippingLabels[rowCount++] = shippingLabelsSub;
          }
        }
      }
    },
    /**
     * 加工・出荷画面にデータを設定する
     */
    setData(data) {
      this.refrigerate = data.refrigerate;

      if (this.mode == "EDIT") {
        this.checkSeaArea = data.harvest_sea_area;
        this.checkCordColor = data.cord_color;
        this.coolingmethodPet = data.cooling_method_pet;
        this.coolingmethodSeaWater = data.cooling_method_seawater;
        this.coolingmethodOther = data.cooling_method_other;
        if (data.refrigerate_temperature != 9999) {
          this.formData.refrigerateTemperature = data.refrigerate_temperature;
        }
      }

      //出荷先設定
      if (data.shipping_destinations.length != 0) {
        for (const row of data.shipping_destinations) {
          if (row.shipping_destination.name) {
            let weightKG = "";
            let weightCan = "";
            let numSSize = "";
            let numMSize = "";
            let numLSize = "";
            let num2LSize = "";
            let doublingRate = 1;   // 初期値は通常（二倍体）を選択する
            // 編集の場合のみ重量をコピー
            if (this.mode == "EDIT") {
              weightKG = row.shipping_destination.weight_kg;
              weightCan = row.shipping_destination.weight_can;
              numSSize = row.shipping_destination.num_s_size;
              numMSize = row.shipping_destination.num_m_size;
              numLSize = row.shipping_destination.num_l_size;
              num2LSize = row.shipping_destination.num_2l_size;
              doublingRate = row.shipping_destination.doubling_rate;
            }
            this.$refs.appendDestinationCard.setDestinations({
              destinationName: row.shipping_destination.name,
              weightKG: weightKG,
              weightCan: weightCan,
              numSSize: numSSize,
              numMSize: numMSize,
              numLSize: numLSize,
              num2LSize: num2LSize,
              doublingRate: doublingRate,
            });
          }
        }
      } else {
        this.$refs.appendDestinationCard.setDestinations({
          destinationName: "",
          weightKG: "",
          weightCan: "",
          numSSize: "",
          numMSize: "",
          numLSize: "",
          num2LSize: "",
          doublingRate: "",
        });
      }

      //出荷ラベル設定
      if (data.shipping_labels.length != 0) {
        for (const row of data.shipping_labels) {
          let expirationDate = "";
          // 編集の場合のみ消費期限をコピー
          if (this.mode == "EDIT") {
            expirationDate = row.shipping_label.expiration_date;
          }
          if (row.shipping_label.name) {
            this.$refs.appendDestinationLabelCard.setDestinationLabels({
              name: row.shipping_label.name,
              expirationDate: expirationDate,
              temperature: row.shipping_label.preservation_temperature,
              seaArea: data.harvest_sea_area,
              processingPerson: row.shipping_label.processing_person,
            });
          }
        }
      } else {
        this.$refs.appendDestinationLabelCard.setDestinationLabels({
          name: "",
          expirationDate: "",
          temperature: "",
          seaArea: "",
          processingPerson: "",
        });
      }
    },
    /**
     * 加工・出荷画面関連
     */
    async loadData() {
      // APIの実行中は画面を編集不可にする
      this.view_status.editable = false;

      if (this.bodyData) {
        // 画面にデータを設定する
        this.setData(this.bodyData);
      } else {
        // 初回加工・出荷情報登録時は出荷前冷蔵の「冷蔵庫」を選択する
        this.refrigerate = 2;
        // 出荷先に空のカードを追加する
        this.$refs.appendDestinationCard.setDestinations({
          destinationName: "",
          weightKG: "",
          weightCan: "",
          numSSize: "",
          numMSize: "",
          numLSize: "",
          num2LSize: "",
          doublingRate: 1,  // 初期値は通常（二倍体）を選択する
        });
        // 出荷ラベルに空のカードを追加する
        this.$refs.appendDestinationLabelCard.setDestinationLabels({
          name: "",
          expirationDate: "",
          temperature: "",
          seaArea: "",
          processingPerson: "",
        });
      }
      // 水揚げ情報を取得する
      if (this.mode == "EDIT") {
        this.unloadingData = await this.getUnloadingData(this.unloadingDateSub);
      } else {
        // 編集時以外の場合、初期選択されている水揚げ日に登録されている水揚げ情報を取得し、初期選択する
        this.setCheckSeaArea(this.unloadingDate);
      }

      // 画面を編集可能にする
      this.view_status.editable = true;
    },
    /**
     * 登録日を更新する
     */
    updateRegistrationDate(registrationDate) {
      this.registrationDate = registrationDate;
    },
    /**
     * 水揚げ日を更新し、水揚げ情報を取得する
     */
    updateUnloadingDate(unloadingDate) {
      this.unloadingDate = unloadingDate;
      // 水揚げ情報を取得
      this.setCheckSeaArea(unloadingDate);
    },
    /**
     * 区画漁業権番号変更処理
     *
     * 水揚げ情報を取得し、登録されている採取海域区分が一つであれば自動選択する
     */
    async setCheckSeaArea(date_string) {
      this.unloadingData = await this.getUnloadingData(date_string);
      if (this.unloadingData.length == 1) {
        this.checkSeaArea = this.unloadingData[0];
        // 自動選択した採取海域を出荷ラベルに反映
        this.changeSeaArea();
      }
    },
    /**
     * 水揚げ情報取得処理
     *
     * 登録されている採取海域区分を重複を取り除いたリストで返却する
     */
    getUnloadingData: function (date_string) {
      return new Promise((resolve) => {
        const date = new DateWrapper(date_string);
        let requestDate = {
          year: date.format.build((d) => new String(d.date.y)),
          month: date.format.build((d) => new String(d.date.m02)),
          day: date.format.build((d) => new String(d.date.d02)),
        };
        // APIのリクエスト
        this.$store.commit("setWaiting", true);
        var data = [];
        Api.call("/haccp/record", {
          uid: this.$store.getters.userId,
          record_type: "UNLOADING",
          record_date: requestDate,
        })
          .then((result) => {
            this.$store.commit("setWaiting", false);
            // 登録されている採取海域区分をリストに追加
            for (const record of result.record_list) {
              data.push(record.body.harvest_sea_area);
            }
            // 採取海域区分の重複を削除
            const set = new Set(data);
            data = [...set];
            resolve(data);
          })
          .catch(() => {
            this.$store.commit("setWaiting", false);
            // 取得に失敗した場合は水揚げ登録内容を空にする
            data = [];
            resolve(data);
          });
      });
    },

    /**
     * カレンダーの月間イベント更新
     */
    updateCalendarEvent(registrationDate) {
      this.applyDataToMonthlyArea(registrationDate);
    },
    /**
     * カレンダー表示用月間イベント取得処理
     */
    applyDataToMonthlyArea(date) {
      const { apiList, mapping } = this.haccpInfoRequest({
        date: new DateWrapper(date),
        daily: false,
        requireUserInfo: false,
      });

      this.$nextTick(() => {
        // APIのリクエスト
        this.$store.commit("setWaiting", true);
        Promise.all(apiList)
          .then((result) => {
            this.$store.commit("setWaiting", false);
            this.events = {
              unloading: result[mapping.unloading].record_list.map(
                (item) => new DateWrapper(item.record_date).format.systemDate
              ),
              shipping: result[mapping.shipping].record_list.map(
                (item) => new DateWrapper(item.record_date).format.systemDate
              ),
              seawater: result[mapping.seawater].record_list.map(
                (item) => new DateWrapper(item.record_date).format.systemDate
              ),
              worklog: result[mapping.worklog].record_list.map(
                (item) => new DateWrapper(item.record_date).format.systemDate
              ),
            };
          })
          .catch((error) => {
            this.$store.commit("setWaiting", false);
            if (error.status == 403) {
              this.errors.push(AlertBuilder.error("権限がありません"));
            } else {
              Api.resolve(error);
            }
          });
      });
    },
    haccpInfoRequest(parameter) {
      const date = parameter["date"] || new DateWrapper(Date.now());
      const daily = parameter["daily"] || false;
      const requireUserInfo = parameter["requireUserInfo"] || false;

      let requestDate = {
        year: date.format.build((d) => new String(d.date.y)),
        month: date.format.build((d) => new String(d.date.m02)),
      };
      if (daily) {
        requestDate["day"] = date.format.build((d) => new String(d.date.d02));
      }
      var apiList = [];
      var keys = [];
      if (requireUserInfo) {
        keys.push("user");
        apiList.push(
          Api.call("/admin/user", {
            purpose: "VIEW_HACCP",
          })
        );
      }

      keys.push(...["worklog", "shipping", "unloading", "seawater"]);
      apiList.push(
        ...[
          Api.call("/work/record", {
            uid: this.$store.getters.userId,
            record_type: "WORKLOG",
            record_date: requestDate,
          }),
          Api.call("/haccp/record", {
            uid: this.$store.getters.userId,
            record_type: "SHIPPING",
            record_date: requestDate,
          }),
          Api.call("/haccp/record", {
            uid: this.$store.getters.userId,
            record_type: "UNLOADING",
            record_date: requestDate,
          }),
          Api.call("/haccp/record", {
            uid: this.$store.getters.userId,
            record_type: "SEAWATER",
            record_date: requestDate,
          }),
        ]
      );
      return {
        apiList: apiList,
        mapping: keys.reduce((map, key, index) => {
          map[key] = index;
          return map;
        }, {}),
      };
    },
    /**
     * 出荷先ラベルの採取海域区分を変更する
     */
    changeSeaArea() {
      this.$refs.appendDestinationLabelCard.changeSeaArea(this.checkSeaArea);
    },
    /**
     * エラーメッセージをクリアする
     */
    clearMessage() {
      this.errors = [];
    },
    /**
     * エラーメッセージを表示する
     */
    showMessage(error) {
      this.errors.push(error);
      window.scrollTo(0, 0);
    },

    /**
     * 格納データを作成する
     */
    buildbodyBodyData() {
      this.destinations = this.getDestinationsData();
      this.destinationLabels = this.getDestinationsLabelData();

      // 出荷先の配列関連
      this.buildShippingDestinations(this.destinations);
      // 出荷ラベルの配列関連
      this.buildShippingLabels(this.destinationLabels);

      // むき身作業中の冷却方法(ペットボトル氷)未選択時の処理
      if (this.coolingmethodPet == "") {
        this.coolingmethodPet = false;
      }
      // むき身作業中の冷却方法(海水氷)未選択時の処理
      if (this.coolingmethodSeaWater == "") {
        this.coolingmethodSeaWater = false;
      }
      var workRefrigerateTemperature = "";
      if (this.formData.refrigerateTemperature === "") {
        workRefrigerateTemperature = 9999;
      } else {
        workRefrigerateTemperature = this.formData.refrigerateTemperature;
      }
      return {
        type: "SHIPPING",
        date: this.registrationDate.replace(/-/g, "/"),
        unloading_date: this.unloadingDate.replace(/-/g, "/"),
        harvest_sea_area: this.checkSeaArea,
        cord_color: this.checkCordColor,
        cooling_method_pet: this.coolingmethodPet,
        cooling_method_seawater: this.coolingmethodSeaWater,
        cooling_method_other: this.coolingmethodOther,
        refrigerate: this.refrigerate,
        refrigerate_temperature: Number(workRefrigerateTemperature),
        shipping_destinations: this.shippingDestinations,
        shipping_labels: this.shippingLabels,
      };
    },
    /**
     * 出荷先の入力内容を取得する
     */
    getDestinationsData() {
      let imput = this.$refs.appendDestinationCard.getDestinations();
      let res = [];
      for (let i = 0; i < imput.length; i++) {
        let item = {
          name: imput[i].destinationName,
          weight_kg: imput[i].weightKG,
          weight_can: imput[i].weightCan,
          num_s_size: imput[i].numSSize,
          num_m_size: imput[i].numMSize,
          num_l_size: imput[i].numLSize,
          num_2l_size: imput[i].num2LSize,
          doubling_rate: imput[i].doublingRate,
        };
        res.push(item);
      }
      return res;
    },
    /**
     * 出荷ラベルの入力内容を取得する
     */
    getDestinationsLabelData() {
      let imput = this.$refs.appendDestinationLabelCard.getDestinationLabels();
      let res = [];
      for (let i = 0; i < imput.length; i++) {
        let item = {
          name: imput[i].name,
          expirationDate: imput[i].expirationDate,
          temperature: imput[i].temperature,
          processingPerson: imput[i].processingPerson,
        };
        res.push(item);
      }
      return res;
    },
    /**
     * 登録用送信データを画面から取得する
     */
    buildRegisterData() {
      switch (this.mode) {
        case "EDIT": // 編集
          return {
            record_type: "SHIPPING",
            record_date: this.registrationDate.replace(/-/g, "/"),
            body: this.buildbodyBodyData(),
            record_id: this.workId,
          };
        case "COPY": // コピー
          return {
            record_type: "SHIPPING",
            record_date: this.registrationDate.replace(/-/g, "/"),
            body: this.buildbodyBodyData(),
          };
        default:
          // 新規
          return {
            record_type: "SHIPPING",
            record_date: this.registrationDate.replace(/-/g, "/"),
            body: this.buildbodyBodyData(),
          };
      }
    },
    /**
     * 更新用登録データを画面から取得する
     */
    buildUpdateData() {},
    /**
     * 保存ボタン押下時に入力内容をチェックする
     */
    inputCheck() {
      this.clearMessage();

      // 入力チェック
      // 出荷先の入力チェックの結果を取得
      this.hasErrorDestinationCard =
        this.$refs.appendDestinationCard.hasErrorFormData;
      // 出荷ラベルの入力チェックの結果を取得
      this.hasErrorDestinationLabelCard =
        this.$refs.appendDestinationLabelCard.hasErrorFormData;
      if (
        this.hasErrorFormData ||
        this.hasErrorDestinationCard ||
        this.hasErrorDestinationLabelCard
      ) {
        this.showMessage(AlertBuilder.error("入力した項目が不正です"));
        return;
      }
      // 出荷ラベルのカード色取得
      this.destinationLabelCardColor =
        this.$refs.appendDestinationLabelCard.cardColor;
      if (
        this.cardColor1 === CARD_COLOR_ERROR ||
        this.cardColor2 === CARD_COLOR_ERROR ||
        this.cardColor3 === CARD_COLOR_ERROR ||
        this.cardColor4 === CARD_COLOR_ERROR ||
        this.cardColor5 === CARD_COLOR_ERROR ||
        this.destinationLabelCardColor === CARD_COLOR_ERROR
      ) {
        this.showMessage(AlertBuilder.error("必須項目が入力されていません"));
        return;
      }

      // 出荷ラベルのエラーメッセージ取得
      this.destinationLabelCardMsg =
        this.$refs.appendDestinationLabelCard.errorMsg;
      if (
        this.cordColorMsg != "" ||
        this.refrigerateMsg != "" ||
        this.destinationLabelCardMsg != ""
      ) {
        // 入力チェックダイアログを表示する
        this.$refs.confirm_input_check.showDialog();
        return;
      }

      this.register();
    },
    /**
     * 最新生産情報取得用送信データを設定する
     */
    buildLatestSearchData() {
      return {
        uid: this.$store.getters.userId,
        record_type: "SHIPPING",
      };
    },
    /**
     * 取得情報を画面に設定する
     */
    setlatestData(data) {
      this.bodyData = data;
      this.loadData();
    },
    /**
     * 最新生産情報を取得する
     */
    latestSearch() {
      let selectUrl = "";
      let postData = null;

      selectUrl = "/haccp/record/latest";

      postData = this.buildLatestSearchData();

      this.$store.commit("setWaiting", true);

      // APIを実行する
      Api.call(selectUrl, postData)
        .then((result) => {
          this.$store.commit("setWaiting", false);
          this.setlatestData(result.body);
        })
        .catch((error) => {
          this.$store.commit("setWaiting", false);
          const message = valueMapper
            .map({
              401: AlertBuilder.invalid(),
            })
            .getOrElse(error.status, AlertBuilder.invalid());
          // 初回の新規登録時は対象レコードが存在しない為、400が返却されるがエラー扱いとしない
          if (error.status == 400) {
            // 取得情報を画面に設定する
            this.loadData();
          }
          if ((message.isInvalid) && (error.status != 400)) {
            Api.resolve(error);
          } else {
            this.showMessage(message);
          }
        });
    },
    register() {
      // 生産情報登録
      let updateUrl = "";
      let postData = null;

      updateUrl = "/haccp/record/update";
      // 編集時のみid指定
      this.workId = "";
      if (this.mode == "EDIT") {
        this.workId = this.id;
      }
      postData = this.buildRegisterData();

      this.$store.commit("setWaiting", true);

      Api.call(updateUrl, postData)
        .then(() => {
          this.$store.commit("setWaiting", false);
          this.$router.push("/product");
        })
        .catch((error) => {
          this.$store.commit("setWaiting", false);
          const message = valueMapper
            .map({
              400: AlertBuilder.error("更新に失敗しました"),
              401: AlertBuilder.invalid(),
              403: AlertBuilder.error("権限がありません"),
            })
            .getOrElse(error.status, AlertBuilder.invalid());
          if (message.isInvalid) {
            Api.resolve(error);
          } else {
            this.showMessage(message);
          }
        });
    },
    cancel() {
      this.$router.push("/product");
    },
  },
};
</script>

<style scoped>
.card-warning {
  background-color: #fff8dc;
}
.card-error {
  background-color: #ffdbe2;
}
.custom-card-title {
  font-size: 32px;
  color: #333;
  line-height: 1.5;
}
.custom-card-subtitle {
  font-size: 24px;
  line-height: 1.5;
}
.custom-card-text {
  font-size: 24px;
  line-height: 1.3;
}
.big-checkbox {
  transform: scale(1.4);
  font-size: 24px;
  margin-left: 24px;
  margin-right: 24px;
}
.big-radio-group {
  transform: scale(1.4);
  font-size: 24px;
  margin-left: 32px;
  margin-right: 32px;
}
</style>
